export const ESCAPE_KEY_CODE = 27;